import axios from 'axios';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { FaHome } from 'react-icons/fa';
import { IoIosArrowForward } from 'react-icons/io';
import { Link, useParams } from 'react-router-dom';
import Footer from '../Component/Footer/Footer';
import product_image_not_found from "../Images/product_image_not_found.jpg";
import product_not_found_image from "../Images/product_not_found.avif";

const ProductList = () => {
    const { category, subcategory } = useParams();
    const [productsToDisplay, setProductsToDisplay] = useState([]);
    const [loading, setLoading] = useState(false);
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    const handleFetch = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            if (category) params.append("main_category", category);
            if (subcategory) params.append("sub_category", subcategory);

            const resp = await axios.get(`https://api.woodsy.co.in/api/brands-with-products?${params.toString()}`);

            if (resp && resp.data) {
                const allProducts = [];
                resp.data.forEach(item => {
                    if (item.products && item.products.length > 0) {
                        item.products.forEach(product => {
                            allProducts.push({
                                ...product,
                                brand: item.brand,
                                sub_category: item.sub_category,
                                images: product.images
                            });
                        });
                    }
                });
                setProductsToDisplay(allProducts);
            } else {
                setProductsToDisplay([]);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            setProductsToDisplay([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const dbounce = setTimeout(() => {
            handleFetch();
        }, 1000);
        return () => clearTimeout(dbounce);
    }, [category, subcategory]);

    return (
        <div>
            <section className='Product-section-banner'>
                <div className='container'>
                    <div className='Product-section-banner-main-con'>
                        <div className='Product-section-banner-con'>
                            <h2>{subcategory ? subcategory.replace(/-/g, ' ') : category ? category.replace(/-/g, ' ') : 'Products'}</h2>
                            <div className='Product-section-banner-content'>
                                <FaHome />
                                <IoIosArrowForward />
                                <Link to="/">Home</Link>
                                {category && (
                                    <>
                                        <IoIosArrowForward />
                                        <Link to={`//${category}`}>{category.replace(/-/g, ' ')}</Link>
                                    </>
                                )}
                                {subcategory && (
                                    <>
                                        <IoIosArrowForward />
                                        <span>{subcategory.replace(/-/g, ' ')}</span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='product-section-2'>
                <div className='container'>
                    <div className='product-section-main-con'>

                        {loading && (
                            <div className='text-center my-5'>
                                <h4>Loading products...</h4>
                            </div>
                        )}

                        {!loading && productsToDisplay.length > 0 && (
                            <div className='row'>
                                {productsToDisplay.map((productItem, index) => {
                                    const { product, price, images, brand,slug } = productItem;

                                    const productName = product?.name || "Product Name";
                                    // const productSlug = product?.slug || "#";

                                    // --- THE CRUCIAL CHANGE IS HERE ---
                                    const firstImage = images && images.length > 0 && images[0]
                                        ? `${images[0]}`
                                        : product_image_not_found;

                                    const secondImage = images && images.length > 1 && images[1]
                                        ? `${images[1]}`
                                        : firstImage;
                                    // --- END OF CRUCIAL CHANGE ---

                                    const mainPrice = price && price.length > 0 ? price[0].price : null;
                                    return (
                                        <div className='col-md-3 col-sm-6 mb-4' key={index}>
                                            <div className='home-trending-section-card-body-con'>
                                                <Link to={`/product-details/${slug}`}>
                                                    <div className='product-wrapper imgloaded'>
                                                        <div className='thumbs product-thumb'>
                                                            <div className='view-image fade_img'>
                                                                <div className='grid-view-item__link'>
                                                                    <img
                                                                        className='image_thumb_swap'
                                                                        height='auto'
                                                                        width='340'
                                                                        src={secondImage}
                                                                        alt={productName}
                                                                        onError={(e) => (e.target.src = product_image_not_found)}
                                                                    />
                                                                    <img
                                                                        className='grid-view-item__image featured-image image_thumb'
                                                                        height='auto'
                                                                        width='340'
                                                                        src={firstImage}
                                                                        alt={productName}
                                                                        onError={(e) => (e.target.src = product_image_not_found)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='home-trending-section-car-details'>
                                                                {brand?.name && <h3>{brand.name}</h3>}
                                                                {/* <h3>{productName}</h3> */}
                                                                {mainPrice ? (
                                                                    <p>
                                                                        ₹ {parseFloat(mainPrice).toFixed(2)} / unit
                                                                        <span className='discount-percentage'> -30%</span>
                                                                        <s className='product-price__price compare_price'>
                                                                            <span className='money'>₹ {(parseFloat(mainPrice) * 1.3).toFixed(2)}</span>
                                                                        </s>
                                                                    </p>
                                                                ) : (
                                                                    <p>Price Not Available</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {!loading && productsToDisplay.length === 0 && (
                            <div className='product-not-found-main-image-con-div'>
                                <div className='product-not-found-main-image-con'>
                                    <div className='product-not-found-main-image'>
                                        <img src={product_not_found_image} alt='product_not_found_image' />
                                    </div>
                                </div>
                                <h4>Product Not Found</h4>
                            </div>
                        )}

                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default ProductList;